import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropMenuComponent } from './drop-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [DropMenuComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [DropMenuComponent]
})
export class DropMenuModule { }

// translation loader moved to SharedModule
